import { Accordion, Badge, Card, Col, OverlayTrigger, Row, Table, Tooltip, Modal, Button } from "react-bootstrap";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";

import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from "../../../signal/allUsersSignal";
import AddFarmerModal from "./AddFarmerModal";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSearchParams } from "react-router-dom";
import { farmerSignal } from "../../../signal/farmerSignal";
import Select from "react-select";
import { farmerVisitsExcelGenerator } from "../../../utilities/excelGenerator";

export default function FarmersVisits() {

    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [visits, setVisits] = useState([]);
    const [visitsToDisplay, setVisitsToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [FarmerId, setFarmerId] = useState(searchParams.get("FarmerId") ? searchParams.get("FarmerId") : "");
    const [userId, setUserId] = useState(searchParams.get("userId") ? searchParams.get("userId") : "");
    const [city, setCity] = useState(searchParams.get("city") ? searchParams.get("city") : "");
    const [state, setState] = useState(searchParams.get("state") ? searchParams.get("state") : "");
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(35);
    const [totalItems, setTotalItems] = useState(0);
    const [farmersList, setFarmersList] = useState([]);
    const [selectedVisit, setSelectedVisit] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);

    // useEffect(() => {
    //     setVisitsToDisplay(visits.filter((item) => {
    //         if (search === "") return true;
    //         if (item?.name?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.gstin?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.phoneNumber?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.address?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.city?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.state?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.pincode?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.email?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.website?.toLowerCase().includes(search.toLowerCase())) return true;
    //         let user = allUsersSignal.value[item.userId];
    //         if (user) {
    //             if (user.name.toLowerCase().includes(search.toLowerCase())) return true;
    //         }
    //         if (moment(item.createdAt).format("DD/MM/YY hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;

    //         return false;
    //     }))
    // }, [search, visits])

    const handleDisplayFields = () => {
        setVisitsToDisplay(visits.filter((item) => {
            if (search === "") return true;
            if (moment(item?.createdAt).format("DD/MM/YY").toLowerCase().includes(search.toLowerCase())) return true;
            if (allUsersSignal?.value[item.userId] && allUsersSignal?.value[item.userId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            // Use embedded farmer name or signal-based lookup
            if (item?.farmerName && item?.farmerName.toLowerCase().includes(search.toLowerCase())) return true;
            if (farmerSignal?.value[item.FarmerId] && farmerSignal?.value[item.FarmerId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.title?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.description?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.status?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.remarks?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.farmerCity?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.farmerContactNo?.toString().includes(search.toLowerCase())) return true;
            return false;
        }))
    }

    const getVisits = useQuery("FarmerVisits", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/task/getFarmerVisits?page=${page}&perPage=${perPage}&startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}&farmerId=${FarmerId}&userId=${userId}&city=${city}&state=${state}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                // Map backend data to flat structure for DataTable
                const mappedVisits = (data.data?.data || []).map((item) => {
                    const t = item.tasks || {};
                    const farmer = item.farmer || {};
                    
                    // Fix: Map media array of strings to array of objects with url property
                    let media = [];
                    if (Array.isArray(t.media)) {
                        media = t.media.map(m => typeof m === "string" ? { url: m } : m);
                    }
                    
                    return {
                        _id: item._id,
                        organisation: item.organisation,
                        date: item.date,
                        title: t.title,
                        description: t.description,
                        destinationLocation: t.destinationLocation,
                        completedAtLocation: t.completedAtLocation,
                        destinationCity: t.destinationCity,
                        destinationState: t.destinationState,
                        destinationArea: t.destinationArea,
                        completedAt: t.completedAt,
                        timeSpentOnVenue: t.timeSpentOnVenue,
                        status: t.status,
                        remarks: t.remarks,
                        media,
                        FarmerId: t.farmerId, // keep FarmerId for table display
                        createdAt: t.createdAt,
                        updatedAt: t.updatedAt,
                        userId: item.user?._id,
                        userName: item.user?.name,
                        // Add farmer details
                        farmerName: farmer.name,
                        farmerAddress: farmer.address,
                        farmerCity: farmer.city,
                        farmerState: farmer.state,
                        farmerPincode: farmer.pincode,
                        farmerContactNo: farmer.contactNo,
                        farmerLandHolding: farmer.landHolding,
                    };
                });
                setVisits(mappedVisits);
                setPage(data.data?.page || 1);
                setPerPage(data.data?.perPage || 35);
                setTotalItems(data.data?.totalItems || 0);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const refetchVisits = () => {
        getVisits.refetch({ cancelRefetch: true });
    }

    const handleFilters = async () => {

        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate: toDate, city: city, state: state, FarmerId: FarmerId, userId: userId })
        setSearchParams(tempSearchParam);
        setPage(1);

        await refetchVisits();
        handleDisplayFields();
    }

    useEffect(() => {
        refetchVisits();
    }, [])

    // Fetch farmers list for dropdown
    useEffect(() => {
        const fetchFarmers = async () => {
            try {
                const resp = await axios.get(`${DEV_SERVER}/farmer/v2/dashboard?page=1&perPage=1000&search=&userId=`, {
                    headers: {
                        Authorization: `Bearer ${userSignal.value?.token}`,
                    }
                });
                if (resp.data.status && resp.data.data?.farmers) {
                    setFarmersList(resp.data.data.farmers);
                }
            } catch (error) {
                console.error("Error fetching farmers:", error);
            }
        };
        if (userSignal.value?.token) {
            fetchFarmers();
        }
    }, [userSignal.value?.token])

    useEffect(() => {
        handleDisplayFields();
    }, [search, visits])

    useEffect(() => {
        refetchVisits();
    }, [page, perPage])

    const columns = [
        {
            name: "Title",
            selector: "title",
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.title}</Tooltip>}>
                    <span>{row?.title}</span>
                </OverlayTrigger>
            },
            center: true,
        },
        {
            name: "Description",
            selector: "description",
            center: true,
            cell: (row) => {
                return row?.description === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}>
                    <span>{row?.description}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Status",
            selector: (row) => {
                return row?.status === "pending" ? <Badge bg="warning">{row?.status}</Badge> : <Badge bg="success">{row?.status}</Badge>
            },
            center: true,
            width: "100px"
        },
        {
            name: "Farmer",
            selector: "FarmerId",
            cell: (row) => {
                // Prefer embedded farmer name, fall back to signal lookup
                const farmerName = row?.farmerName || (farmerSignal?.value && farmerSignal?.value[row?.FarmerId]?.name);
                if (farmerName) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{farmerName}</Tooltip>}>
                        <span>{farmerName}</span>
                    </OverlayTrigger>
                }
                return "-"
            },
            center: true,
            width: "200px"
        },
        {
            name: "Remarks",
            selector: "remarks",
            center: true,
            cell: (row) => {
                return row?.remarks === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.remarks}</Tooltip>}>
                    <span>{row?.remarks}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Remark image",
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "Address",
            selector: (row) => {
                // Only include non-empty address parts
                const parts = [
                    row?.destinationArea,
                    row?.destinationCity,
                    row?.destinationState
                ].filter(Boolean); // removes undefined, null, empty string
                const address = parts.join(", ");
                return (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip style={{ position: "fixed" }}>{address}</Tooltip>}
                    >
                        <span>{address || "NA"}</span>
                    </OverlayTrigger>
                );
            },
            width: "300px",
            center: true,
        },
        {
            name: "User",
            selector: (row) => {
                if (row?.userId?.length && allUsersSignal?.value && allUsersSignal?.value[row?.userId]) {
                    return (
                        <div style={{ columnGap: "0.4rem" }}>
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            },
            center: true,
            width: "150px"
        },
        {
            name: "Completed Location",
            width: "100px",
            selector: (row) => {

                return <span className="d-flex justify-content-between align-items-start" style={{ columnGap: "0.5rem" }}>
                    {(row?.completedAt === "" || row?.completedAt === null || row?.completedAt === undefined || row?.completedAt === 0) ? "-" :
                        <span className="d-flex flex-column">
                            <p className="mb-1">{moment(row?.completedAt).format("DD/MM/YY")}</p>
                            <p className="mb-0" style={{ color: "rgba(0, 0, 0, 0.625)", fontSize: "10px" }}>{moment(row?.completedAt).format("hh:mm A")}</p>
                        </span>
                    }

                    {row?.completedAtLocation?.length > 0 && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.completedAtLocation[0]},${row?.completedAtLocation[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>}

                </span>
            },
            center: true,
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Farmers Visits</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" defaultValue={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" defaultValue={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="city">City</label>
                                                    <input type="text" id="city" className="form-control" placeholder="Enter City" value={city} onChange={(e) => {
                                                        setCity(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="state">State</label>
                                                    <input type="text" id="state" className="form-control" placeholder="Enter State" value={state} onChange={(e) => {
                                                        setState(e.target.value)
                                                    }} />
                                                </div>

                                                <div>
                                                    <label htmlFor="Farmer">Farmer</label>
                                                    <Select
                                                        options={farmersList && farmersList.length > 0 ? farmersList.map((farmer) => {
                                                            return { value: farmer.id, label: farmer.name }
                                                        }) : []}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setFarmerId(e.value);
                                                            } else {
                                                                setFarmerId("");
                                                            }
                                                        }}

                                                        value={FarmerId && farmersList && farmersList.find(f => f.id === FarmerId) ? { value: FarmerId, label: farmersList.find(f => f.id === FarmerId).name } : null}

                                                        isClearable
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="user">User</label>
                                                    <Select
                                                        options={allUsersSignal?.value ? Object.keys(allUsersSignal?.value).map((key) => {
                                                            return { value: allUsersSignal?.value[key].id, label: allUsersSignal?.value[key].name }
                                                        }) : []}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setUserId(e.value);
                                                            } else {
                                                                setUserId("");
                                                            }
                                                        }}

                                                        value={allUsersSignal?.value && userId && allUsersSignal?.value[userId] ? { value: allUsersSignal?.value[userId].id, label: allUsersSignal?.value[userId].name } : null}

                                                        isClearable
                                                    />
                                                </div>

                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setCity("");
                                                    setState("");
                                                    setFarmerId("");
                                                    setUserId("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minAmount: 0, maxAmount: 0, stageFilter: "", FarmerId: "", userId: "" });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-4" style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem", justifyContent: "space-between" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>

                                    <div className="d-flex col-4" style={{ columnGap: "1rem", whiteSpace: "nowrap"}}>
                                        <Card className="bg-soft-info col-8 p-0 mb-0" style={{ height: "60px" }}>
                                            <Card.Body className="py-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="bg-soft-info rounded p-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <div className="text-end">
                                                        <h4 className="counter">{totalItems}</h4>
                                                        Total Visits
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                        <button className="btn btn-success"
                                            disabled={(getVisits.isFetching || getVisits.isLoading)}
                                            onClick={() => farmerVisitsExcelGenerator(visits, `${"Farmer Visits"}-${fromDate}-${toDate}`)}
                                        >
                                            <svg id="SvgjsSvg1001" width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs"><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 18765 21993" width="20" height="20"><path fill-rule="nonzero" d="M4317 0l9063 0c285,0 530,102 731,303l4351 4350c201,202 303,447 303,732l0 13155c0,910 -742,1652 -1653,1652l-11137 0c-53,0 -98,-28 -123,-75 -24,-46 -20,-99 10,-142l777 -1104c26,-38 66,-59 112,-59l10361 0c150,0 273,-123 273,-272l0 -12943 -2764 0c-801,0 -1454,-653 -1454,-1454l0 -2763 -8850 0c-150,0 -273,123 -273,272l0 10524c0,75 -62,137 -138,137l-1104 0c-76,0 -138,-62 -138,-137l0 -10524c0,-910 742,-1652 1653,-1652zm2039 17106l-1288 0c-159,0 -288,-129 -288,-288l0 -3424c0,-158 -129,-287 -288,-287l-2339 0c-159,0 -288,129 -288,287l0 3424c0,159 -129,288 -288,288l-1288 0c-110,0 -205,58 -255,155 -51,98 -44,209 20,299l3033 4311c56,79 139,122 235,122 97,0 180,-43 236,-122l3033 -4311c64,-90 71,-201 20,-299 -50,-97 -145,-155 -255,-155zm-394 -12701l3588 0c107,0 194,88 194,195l0 775c0,107 -87,194 -194,194l-3588 0c-107,0 -194,-87 -194,-194l0 -775c0,-107 87,-195 194,-195zm970 3727l0 2150 4056 0 0 -2150 -4056 0zm0 3314l0 2150 4056 0 0 -2150 -4056 0zm5220 -1164l2345 0 0 -2150 -2345 0 0 2150zm2345 1164l-2345 0 0 2150 2345 0 0 -2150zm1164 -3509l0 2539 0 775 0 2539 0 355 0 420c0,107 -87,194 -194,194l-9505 0c-107,0 -194,-87 -194,-194l0 -420 0 -355 0 -2539 0 -775 0 -2539 0 -355 0 -420c0,-107 87,-194 194,-194l9505 0c107,0 194,87 194,194l0 420 0 355z" fill="white" class="color000 svgShape"></path></svg></g></svg> Export
                                        </button>
                                    </div>
                                </div>
                                {(!getVisits.isLoading && !getVisits?.isFetching) &&
                                    <DataTable
                                        columns={columns} 
                                        data={visitsToDisplay} 
                                        pagination={true}
                                        paginationServer={true} 
                                        paginationTotalRows={totalItems} 
                                        paginationPerPage={perPage} 
                                        paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                        paginationDefaultPage={page}
                                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                            setPerPage(currentRowsPerPage);
                                        }}
                                        onChangePage={(currentPage) => {
                                            setPage(currentPage);
                                        }}
                                        onRowClicked={(row) => {
                                            setSelectedVisit(row);
                                            setShowDetailsModal(true);
                                        }}
                                        pointerOnHover
                                        highlightOnHover
                                    />}
                                {(getVisits.isLoading || getVisits?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            {/* Visit Details Modal */}
            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Visit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedVisit && (
                        <div className="visit-details">
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="mb-0">Visit Information</h5>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={6} className="mb-2">
                                            <strong>Title:</strong>
                                            <p className="mb-1">{selectedVisit.title || "NA"}</p>
                                        </Col>
                                        <Col md={6} className="mb-2">
                                            <strong>Status:</strong>
                                            <p className="mb-1">
                                                <Badge bg={selectedVisit.status === "completed" ? "success" : "warning"}>
                                                    {selectedVisit.status}
                                                </Badge>
                                            </p>
                                        </Col>
                                        <Col md={12} className="mb-2">
                                            <strong>Description:</strong>
                                            <p className="mb-1">{selectedVisit.description || "NA"}</p>
                                        </Col>
                                        <Col md={12} className="mb-2">
                                            <strong>Remarks:</strong>
                                            <p className="mb-1">{selectedVisit.remarks || "NA"}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Card className="mb-3">
                                        <Card.Header>
                                            <h5 className="mb-0">Farmer Details</h5>
                                        </Card.Header>
                                        <Card.Body>
                                            <p className="mb-2"><strong>Name:</strong> {selectedVisit.farmerName || "Unknown"}</p>
                                            <p className="mb-2"><strong>Address:</strong> {selectedVisit.farmerAddress || "NA"}</p>
                                            <p className="mb-2"><strong>City:</strong> {selectedVisit.farmerCity || "NA"}</p>
                                            <p className="mb-2"><strong>State:</strong> {selectedVisit.farmerState || "NA"}</p>
                                            <p className="mb-2"><strong>Pincode:</strong> {selectedVisit.farmerPincode || "NA"}</p>
                                            <p className="mb-2"><strong>Contact:</strong> {selectedVisit.farmerContactNo || "NA"}</p>
                                            <p className="mb-0"><strong>Land Holding:</strong> {selectedVisit.farmerLandHolding || "NA"} acres</p>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={6}>
                                    <Card className="mb-3">
                                        <Card.Header>
                                            <h5 className="mb-0">Visit Location</h5>
                                        </Card.Header>
                                        <Card.Body>
                                            <p className="mb-2"><strong>Destination Area:</strong> {selectedVisit.destinationArea || "NA"}</p>
                                            <p className="mb-2"><strong>Destination City:</strong> {selectedVisit.destinationCity || "NA"}</p>
                                            <p className="mb-2"><strong>Destination State:</strong> {selectedVisit.destinationState || "NA"}</p>
                                            <p className="mb-2"><strong>Completed At:</strong> {selectedVisit.completedAt ? moment(selectedVisit.completedAt).format("DD/MM/YY hh:mm A") : "NA"}</p>
                                            <p className="mb-2"><strong>Time Spent:</strong> {selectedVisit.timeSpentOnVenue || "NA"}</p>
                                            {selectedVisit.completedAtLocation?.length > 0 && (
                                                <a 
                                                    href={`https://www.google.com/maps/search/?api=1&query=${selectedVisit.completedAtLocation[0]},${selectedVisit.completedAtLocation[1]}`} 
                                                    target="_blank" 
                                                    rel="noreferrer"
                                                    className="btn btn-sm btn-outline-primary mt-2"
                                                >
                                                    <i className="fas fa-map-marker-alt me-1"></i>
                                                    View on Map
                                                </a>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="mb-0">User Information</h5>
                                </Card.Header>
                                <Card.Body>
                                    <p className="mb-2"><strong>User:</strong> {selectedVisit.userName || (allUsersSignal?.value?.[selectedVisit.userId]?.name) || "NA"}</p>
                                    <p className="mb-0"><strong>Created At:</strong> {selectedVisit.createdAt ? moment(selectedVisit.createdAt).format("DD/MM/YY hh:mm A") : "NA"}</p>
                                </Card.Body>
                            </Card>

                            {selectedVisit.media?.length > 0 && (
                                <Card>
                                    <Card.Header>
                                        <h5 className="mb-0">Media</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                                            {selectedVisit.media.map((m, idx) => (
                                                <Zoom key={idx}>
                                                    <img 
                                                        src={m.url} 
                                                        alt={`media-${idx}`}
                                                        style={{ 
                                                            width: "100px", 
                                                            height: "100px", 
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            cursor: "pointer"
                                                        }} 
                                                    />
                                                </Zoom>
                                            ))}
                                        </div>
                                    </Card.Body>
                                </Card>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}